(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["w27-category"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-collage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-fabrics"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-featured"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w27-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const trigger=event.target.closest('[data-w27-preview]');if(trigger){const scope=trigger.closest('.w27');const dialog=scope.querySelector('[data-w27-dialog="'+trigger.dataset.w27Preview+'"]');if(dialog)dialog.showModal();}if(event.target.matches('.w27-dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();
})();
